export default {
  title: 'Möchten Sie sich wirklich abmelden?',
  buttons: {
    logout: 'Abmelden',
    cancel: 'Abbrechen',
  },
};
